module.exports = __webpack_public_path__ + "img/depmap_logo.4ace978c.png";